var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { bindable } from "aurelia-framework";
import * as Enumerable from "linq";
import { Client } from "../../../views/app/client/client";
import { CloneUtility } from "../../../utilities/clone";
import { NotificationType } from "../../../services/basics/notification-client.service";
import { LotteryKeyHelper } from "../../../services/modules/brand-client.service";
var BaseChooseTicket = /** @class */ (function () {
    function BaseChooseTicket(element, bindingSignaler, gamePlayerTicketClientService, notificationClientService, i18N, dialogClientService) {
        this.element = element;
        this.bindingSignaler = bindingSignaler;
        this.gamePlayerTicketClientService = gamePlayerTicketClientService;
        this.notificationClientService = notificationClientService;
        this.i18N = i18N;
        this.dialogClientService = dialogClientService;
        this.isFromCart = false;
        this.main = [];
        this.bonus = [];
        this.mainNumbers = [];
        this.bonusNumbers = [];
    }
    BaseChooseTicket.prototype.activate = function (model) {
        if (!model)
            return;
        var lottery = model.lottery;
        var ticket = model.ticket;
        this.key = LotteryKeyHelper.getKey(lottery.lotteryName);
        this.lottery = lottery;
        this.ticketInEdit = ticket;
        this.brandLotteryId = lottery.brandLotteryId;
        this.bundleId = model.bundleId;
        this.bundleKey = model.bundleKey;
        this.isFromCart = model.isFromCart;
        this.cartGuid = model.cartGuid;
        this.lotteryChanged();
        this.ticketInEditChanged();
        this.updateTicketNumbers();
    };
    BaseChooseTicket.prototype.lotteryWithBonus = function () {
        return this.lottery.drawnBonusNumbers;
    };
    BaseChooseTicket.prototype.ticketInEditChanged = function () {
        if (this.ticketInEdit) {
            this.main = this.ticketInEdit.main ? Enumerable.from(CloneUtility.clone(this.ticketInEdit.main)).orderBy(function (x) { return x; }).toArray() : [];
            this.bonus = this.ticketInEdit.bonus ? Enumerable.from(CloneUtility.clone(this.ticketInEdit.bonus)).orderBy(function (x) { return x; }).toArray() : [];
        }
        else {
            this.main = [];
            this.bonus = [];
        }
        this.updateTicketNumbers();
    };
    BaseChooseTicket.prototype.lotteryChanged = function () {
        if (this.lottery) {
            this.mainNumbers = Enumerable.range(this.lottery.drawMinimumNumber, (this.lottery.drawMaximumNumber + 1) - this.lottery.drawMinimumNumber).toArray();
            if (this.lottery.drawnBonusMinimumNumber != null && this.lottery.drawnBonusMaximumNumber != null)
                this.bonusNumbers = Enumerable.range(this.lottery.drawnBonusMinimumNumber, (this.lottery.drawnBonusMaximumNumber + 1) - this.lottery.drawnBonusMinimumNumber).toArray();
            else
                this.bonusNumbers = [];
        }
        else {
            this.mainNumbers = [];
            this.bonusNumbers = [];
        }
    };
    BaseChooseTicket.prototype.getRemainingNumbers = function () {
        return this.getRemainingMain() + this.getRemainingBonus();
    };
    Object.defineProperty(BaseChooseTicket.prototype, "drawnBonusNumbers", {
        get: function () {
            return this.lottery ? Enumerable.range(1, this.lottery.drawnBonusNumbers).toArray() : [];
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BaseChooseTicket.prototype, "drawnNumbers", {
        get: function () {
            return this.lottery ? Enumerable.range(1, this.lottery.drawnNumbers).toArray() : [];
        },
        enumerable: false,
        configurable: true
    });
    BaseChooseTicket.prototype.getRemainingBonus = function () {
        if (this.lottery)
            return this.lottery.drawnBonusNumbers - this.bonus.length;
        return 0;
    };
    BaseChooseTicket.prototype.getRemainingMain = function () {
        if (this.lottery)
            return this.lottery.drawnNumbers - this.main.length;
        return 0;
    };
    BaseChooseTicket.prototype.pickRandom = function () {
        var numbersToPick = 0;
        var bonusToPick = 0;
        if (this.lottery.drawnNumbers === this.main.length) {
            this.main = [];
        }
        if (this.lottery.drawnBonusNumbers === this.bonus.length) {
            this.bonus = [];
        }
        numbersToPick = this.lottery.drawnNumbers - this.main.length;
        bonusToPick = this.lottery.drawnBonusNumbers - this.bonus.length;
        for (var i = 1; i <= numbersToPick; i++) {
            var number = 0;
            do {
                number = this.getRandom(this.lottery.drawMinimumNumber, this.lottery.drawMaximumNumber);
            } while (Enumerable.from(this.main).contains(number));
            this.main.push(number);
        }
        for (var i = 1; i <= bonusToPick; i++) {
            var number = 0;
            do {
                number = this.getRandom(this.lottery.drawnBonusMinimumNumber, this.lottery.drawnBonusMaximumNumber);
            } while (Enumerable.from(this.bonus).contains(number));
            this.bonus.push(number);
        }
        this.updateTicketNumbers();
    };
    BaseChooseTicket.prototype.updateTicketNumbers = function () {
        this.bindingSignaler.signal('update-selected-ticket-numbers');
    };
    BaseChooseTicket.prototype.getRandom = function (min, max) {
        return Math.floor(Math.random() * (max - min + 1) + min);
    };
    BaseChooseTicket.prototype.done = function () {
        var _this = this;
        if (this.getRemainingNumbers() == 0) {
            this.ticketInEdit.main = this.main;
            this.ticketInEdit.bonus = this.bonus;
            this.save(this.ticketInEdit).then(function (x) {
                var customEvent = new CustomEvent("on-item-saved", { bubbles: true, detail: {} });
                _this.element.dispatchEvent(customEvent);
            }, function (e) {
                _this.notificationClientService.show("Error", "Error saving ticket!", NotificationType.Error);
            });
        }
        else {
            this.notificationClientService.show(this.i18N.tr(this.key + "-please-select-all-numbers"), "", NotificationType.Warning);
        }
        this.ticketInEdit = null;
        this.dialogClientService.hide();
    };
    BaseChooseTicket.prototype.save = function (ticket) {
        var _this = this;
        return this.gamePlayerTicketClientService.createOrModifyTicket(this.getCreateTicketRequest(ticket)).catch(function (x) {
            _this.notificationClientService.show("Error", _this.i18N.tr(x.response), NotificationType.Error);
        });
    };
    BaseChooseTicket.prototype.getCreateTicketRequest = function (ticket) {
        return {
            bundleId: this.bundleId ? Number(this.bundleId) : null,
            bundleGuid: this.getRemainingNumbers() == 0 ? this.bundleGuid : null,
            cartGuid: this.getRemainingNumbers() == 0 ? this.cartGuid : null,
            sequenceNumber: 0,
            bonusPicks: ticket.bonus.join(","),
            mainPicks: ticket.main.join(","),
            ticketGuid: ticket.guid,
            ticketId: ticket.ticketId,
            brandLotteryId: this.brandLotteryId,
            draws: this.numberOfDraws ? this.numberOfDraws : 1,
            recordedSessionId: Client.RECORDING_SESSION_ID,
            isFromCart: this.isFromCart
        };
    };
    BaseChooseTicket.prototype.isSelectedMainNumber = function (number) {
        var index = this.main.indexOf(number);
        return index >= 0;
    };
    BaseChooseTicket.prototype.isSelectedBonusNumber = function (number) {
        var index = this.bonus.indexOf(number);
        return index >= 0;
    };
    BaseChooseTicket.prototype.addMainNumber = function (number) {
        var index = this.main.indexOf(number);
        if (index >= 0) {
            this.main.splice(index, 1);
        }
        else if (this.main.length < this.lottery.drawnNumbers) {
            this.main.push(number);
        }
        this.updateTicketNumbers();
    };
    BaseChooseTicket.prototype.addBonusNumber = function (number) {
        var index = this.bonus.indexOf(number);
        if (index >= 0) {
            this.bonus.splice(index, 1);
        }
        else if (this.bonus.length < this.lottery.drawnBonusNumbers) {
            this.bonus.push(number);
        }
        this.updateTicketNumbers();
    };
    __decorate([
        bindable(),
        __metadata("design:type", String)
    ], BaseChooseTicket.prototype, "key", void 0);
    __decorate([
        bindable(),
        __metadata("design:type", Boolean)
    ], BaseChooseTicket.prototype, "isFromCart", void 0);
    __decorate([
        bindable(),
        __metadata("design:type", Number)
    ], BaseChooseTicket.prototype, "numberOfDraws", void 0);
    __decorate([
        bindable(),
        __metadata("design:type", Object)
    ], BaseChooseTicket.prototype, "ticketInEdit", void 0);
    __decorate([
        bindable(),
        __metadata("design:type", Object)
    ], BaseChooseTicket.prototype, "lottery", void 0);
    __decorate([
        bindable(),
        __metadata("design:type", Number)
    ], BaseChooseTicket.prototype, "brandLotteryId", void 0);
    __decorate([
        bindable(),
        __metadata("design:type", String)
    ], BaseChooseTicket.prototype, "cartGuid", void 0);
    __decorate([
        bindable(),
        __metadata("design:type", String)
    ], BaseChooseTicket.prototype, "bundleGuid", void 0);
    __decorate([
        bindable(),
        __metadata("design:type", String)
    ], BaseChooseTicket.prototype, "bundleId", void 0);
    return BaseChooseTicket;
}());
export { BaseChooseTicket };
